import { BranchNoticeAction } from '@pages/Authorized/Branch/NoticePage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchNoticeAction) => void
}

export default function BranchNoticeTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [{ label: '공지사항 추가', buttonType: 'primary', onClick: () => onAction('add') }]

  return <PageTitle title="공지사항" actions={actions} />
}
